import React, { useState } from 'react';

const testimonials = [
  { name:'Rajesh Kumar', role:'CEO, ShopEase India', quote:'Cegon Soft Tech delivered our MERN platform 2 weeks ahead of schedule. Code quality is exceptional and our sales grew 140% post-launch. Their attention to detail is unmatched.', project:'E-Commerce Platform' },
  { name:'Priya Sharma', role:'CTO, FinTechPro', quote:'The Java microservices architecture handles 100k+ daily transactions without fault. The team\'s technical depth and communication throughout the project was world-class.', project:'Banking Microservices' },
  { name:'Michael Chen', role:'Founder, LogiTrack', quote:'Our Flutter app reached 50k downloads in the first month. Cegon Soft Tech nailed both the UI and performance — it genuinely feels native on both platforms.', project:'Logistics Mobile App' },
  { name:'Anitha Reddy', role:'Marketing Head, BrandStar', quote:'Cegon Soft Tech\'s digital marketing team tripled our organic traffic in 6 months. Transparent reporting and data-driven strategy we could actually trust.', project:'Digital Marketing' },
];

const JOURNAL = [
  { img:'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=600&auto=format&fit=crop&q=70', cap:'Spaces That Breathe', sub:'On architectural coding principles' },
  { img:'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&auto=format&fit=crop&q=70', cap:'Textures of Stillness', sub:'Crafting calm user interfaces' },
  { img:'https://images.unsplash.com/photo-1617806118233-18e1de247200?w=600&auto=format&fit=crop&q=70', cap:'Light as a Material', sub:'Design systems that illuminate' },
];

const Testimonials = () => {
  const [active, setActive] = useState(0);
  const t = testimonials[active];

  return (
    <>
      {/* Testimonial */}
      <section style={{ background:'var(--bg3)', position:'relative', overflow:'hidden' }}>
        <div style={{ position:'absolute', inset:0,
          backgroundImage:`url('https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=1800&auto=format&fit=crop&q=50')`,
          backgroundSize:'cover', backgroundPosition:'center', opacity:0.07 }} />
        <div className="container position-relative section-pad" style={{ zIndex:1 }}>
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <span className="section-label">Client Stories</span>
              <blockquote style={{ fontFamily:'var(--font-disp)', fontSize:'clamp(1.5rem, 3vw, 2.2rem)', fontWeight:300, fontStyle:'italic', lineHeight:1.5, color:'var(--cream2)', marginBottom:'2.5rem' }}>
                "{t.quote}"
              </blockquote>
              <div style={{ width:40, height:1, background:'var(--tan)', margin:'0 auto 20px' }} />
              <div style={{ fontFamily:'var(--font-body)', fontSize:'0.8rem', letterSpacing:'0.15em', textTransform:'uppercase', color:'var(--tan)', marginBottom:4 }}>{t.name}</div>
              <div style={{ color:'var(--muted)', fontSize:'0.8rem' }}>{t.role} — {t.project}</div>

              <div className="d-flex justify-content-center gap-3 mt-5">
                {testimonials.map((_,i) => (
                  <button key={i} onClick={() => setActive(i)} style={{
                    width: active===i ? 32 : 10, height:10,
                    borderRadius: active===i ? 5 : 50,
                    background: active===i ? 'var(--tan)' : 'rgba(196,168,130,0.25)',
                    border:'none', cursor:'pointer', transition:'all 0.35s ease',
                  }} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Notes from the studio / Journal */}
      <section className="section-pad" style={{ background:'var(--cream2)' }}>
        <div className="container">
          <div className="text-center mb-5">
            <span style={{ fontFamily:'var(--font-body)', fontSize:'0.65rem', letterSpacing:'0.3em', textTransform:'uppercase', color:'var(--tan2)', display:'block', marginBottom:'1rem' }}>Journal</span>
            <h2 style={{ fontFamily:'var(--font-disp)', fontSize:'clamp(2.4rem,5vw,4rem)', fontWeight:400, color:'var(--bg)', letterSpacing:'-0.01em' }}>Notes From the <em>Studio</em></h2>
          </div>
          <div className="row g-4">
            {JOURNAL.map((j,i) => (
              <div key={i} className="col-md-4">
                <div style={{ overflow:'hidden', marginBottom:16 }}>
                  <img src={j.img} alt={j.cap} style={{ width:'100%', height:260, objectFit:'cover', filter:'sepia(20%) brightness(0.9)', transition:'transform 0.6s', display:'block' }}
                    onMouseEnter={e => e.target.style.transform='scale(1.05)'}
                    onMouseLeave={e => e.target.style.transform='scale(1)'}
                  />
                </div>
                <div style={{ fontFamily:'var(--font-body)', fontSize:'0.62rem', letterSpacing:'0.25em', textTransform:'uppercase', color:'var(--tan2)', marginBottom:6 }}>{j.sub}</div>
                <h5 style={{ fontFamily:'var(--font-disp)', fontSize:'1.3rem', fontWeight:400, color:'var(--bg)', letterSpacing:'0.02em' }}>{j.cap}</h5>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimonials;
